import axios from "@/libs/api.request";
// 获取退件重派列表
export const operBounceBack = params => {
  return axios.request({
    url: `/warehouse/getBounceBack`,
    params,
    method: "get"
  });
};

export const operPostBounceBack = data => {
  return axios.request({
    url: `/warehouse/addBounceBack`,
    data,
    method: "post"
  });
};
